module.exports = __webpack_public_path__ + "img/horizontal_6_6_5012.944766f9.png";